import { Route, Routes } from "react-router-dom";
import { AuthGate } from "./components/AuthGate";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RoleRoute } from "./components/RoleRoute";
import { AdminUsers } from "./routes/AdminUsers";
import { AuthPage } from "./routes/AuthPage";
import { EditProject } from "./routes/EditProject";
import { ForgotPassword } from "./routes/ForgotPassword";
import { Home } from "./routes/Home";
import { NewProject } from "./routes/NewProject";
import { NotFound } from "./routes/NotFound";
import { Profile } from "./routes/Profile";
import { ProjectDetail } from "./routes/ProjectDetail";
import { UserProfile } from "./routes/UserProfile";
import { VerifyEmail } from "./routes/VerifyEmail";

export function App() {
  return (
    <AuthGate>
      <Routes>
        <Route path="/login" element={<AuthPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route element={<Layout />}>
          <Route element={<ProtectedRoute />}>
            <Route index element={<Home />} />
            <Route path="projects/new" element={<NewProject />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="projects/:id/edit" element={<EditProject />} />
            <Route path="profile" element={<Profile />} />
            <Route path="users/:uid" element={<UserProfile />} />
          </Route>
          <Route element={<RoleRoute roles={["admin"]} />}>
            <Route path="admin/users" element={<AdminUsers />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthGate>
  );
}
